import React, { Component } from "react";
import ShowValue from "../../components/ShowValue";
import ApiAssets from "../../utils/api.assets";

class PreviousList extends Component {
  constructor(props) {
    super(props);
    this.state = { previous: [], loading: true };

    ApiAssets.getOnlyLander(this.props.assetline).then(response => {
      if (response.data) {
        this.setState({
          previous: response.data,
          loading: false
        });
      }
    });

  }

  componentDidMount() {
    ApiAssets.getOnlyLander(this.props.assetline).then(response => {
      if (response.data) {
        this.setState({
          previous: response.data,
          loading: false
        });
      }
    });
  }

  render() {
    return (
      <div className="pt-5 mt-5">
        <h2 className="asset-list">Previous Landers</h2>
        <hr />
        <p
          hidden={this.state.previous.length <= 1 || this.state.loading}
          className="list-header"
        >
          Current Owner:
        </p>
        <div hidden={this.state.previous.length < 1 || !this.state.loading}>
          <img
            className="d-block m-auto loading-img pb-1"
            width="50"
            src="/assets/images/loading.gif"
            alt="loading icon"
          />
          <p className="text-center text-primary">Loading Landers...</p>
        </div>
        <ul className="list-unstyled list-formatted pl-0 ml-0">
          {this.state.previous.map((lander, index) => {
            if (lander) {
              return (
                <li className="asset-lander" key={index} hidden={!lander.name}>
                  <div className="row">
                    <div className="col-md-6">
                      <span className="float-left">
                        {this.state.previous.length - index - 1}º -{" "}
                        {lander.name}
                      </span>
                    </div>
                    <div className="col-md-6">
                      <ShowValue
                        className="float-right"
                        btc={lander.previous_lander_asset_price}
                      />
                    </div>
                  </div>
                </li>
              );
            }
          })}
          <li className="asset-lander" hidden={this.state.previous.length > 1}>
            This asset belongs to:
            <h3>
              Cryptolands.i
              <img src="/assets/images/sun.jpg" alt="sun" width="22" />
            </h3>
          </li>
        </ul>
      </div>
    );
  }
}

export default PreviousList;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/previous-list.js